// Liquid Glass Theme Configuration
import type { Theme } from './types';
import { buildThemeCssVarMap, themeVarMapToCss } from './tokens';

export const liquidGlassTheme: Theme = {
    name: 'liquid-glass',
    colors: {
        // Primary - Violet/Purple gradient base
        primary: '#8b5cf6', // violet-500
        primaryHover: '#a78bfa', // violet-400
        primaryActive: '#7c3aed', // violet-600

        // Secondary - Translucent white
        secondary: 'rgba(255, 255, 255, 0.15)',
        secondaryHover: 'rgba(255, 255, 255, 0.25)',
        secondaryActive: 'rgba(255, 255, 255, 0.1)',

        // Backgrounds - Translucent
        background: 'rgba(15, 23, 42, 0.95)', // dark base for glassmorphism
        surface: 'rgba(255, 255, 255, 0.08)',
        surfaceHover: 'rgba(255, 255, 255, 0.12)',

        // Text - Light for dark backgrounds
        text: '#f8fafc', // slate-50
        textMuted: '#94a3b8', // slate-400
        textInverse: '#0f172a', // slate-900

        // Borders - Subtle, translucent
        border: 'rgba(255, 255, 255, 0.15)',
        borderLight: 'rgba(255, 255, 255, 0.08)',

        // Status - Softer, more saturated
        success: '#22c55e', // green-500
        warning: '#eab308', // yellow-500
        error: '#f43f5e', // rose-500
        info: '#06b6d4', // cyan-500
    },
    effects: {
        // Border - Thinner, subtle
        borderWidth: '1px',
        borderRadius: '24px',
        borderRadiusSmall: '16px',
        borderRadiusLarge: '32px',

        // Shadows - Soft, diffused glow
        shadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.05)',
        shadowHover: '0 12px 48px rgba(139, 92, 246, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1)',
        shadowActive: '0 4px 16px rgba(0, 0, 0, 0.15)',

        // Blur - Key glassmorphism effect
        blur: 'blur(20px)',

        // Transitions - Smooth, fluid
        transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        transitionFast: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',

        // Hover transforms - Subtle float
        hoverTranslateX: '0px',
        hoverTranslateY: '-2px',
    },
};

// CSS variables for liquid glass theme
export const liquidGlassCSSVarMap = buildThemeCssVarMap(liquidGlassTheme);
export const liquidGlassCSSVars = themeVarMapToCss(liquidGlassCSSVarMap);
